import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#262626",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 4.49866C3.82843 4.49866 4.5 3.82708 4.5 2.99866C4.5 2.17023 3.82843 1.49866 3 1.49866C2.17157 1.49866 1.5 2.17023 1.5 2.99866C1.5 3.82708 2.17157 4.49866 3 4.49866Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 10.4987C3.82843 10.4987 4.5 9.82708 4.5 8.99866C4.5 8.17023 3.82843 7.49866 3 7.49866C2.17157 7.49866 1.5 8.17023 1.5 8.99866C1.5 9.82708 2.17157 10.4987 3 10.4987Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 16.4987C3.82843 16.4987 4.5 15.8271 4.5 14.9987C4.5 14.1702 3.82843 13.4987 3 13.4987C2.17157 13.4987 1.5 14.1702 1.5 14.9987C1.5 15.8271 2.17157 16.4987 3 16.4987Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 3.49866H16.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 9.49866H16.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 15.4987H16.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20stroke%3D%22%23262626%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M3%204.49866C3.82843%204.49866%204.5%203.82708%204.5%202.99866C4.5%202.17023%203.82843%201.49866%203%201.49866C2.17157%201.49866%201.5%202.17023%201.5%202.99866C1.5%203.82708%202.17157%204.49866%203%204.49866Z%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M3%2010.4987C3.82843%2010.4987%204.5%209.82708%204.5%208.99866C4.5%208.17023%203.82843%207.49866%203%207.49866C2.17157%207.49866%201.5%208.17023%201.5%208.99866C1.5%209.82708%202.17157%2010.4987%203%2010.4987Z%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M3%2016.4987C3.82843%2016.4987%204.5%2015.8271%204.5%2014.9987C4.5%2014.1702%203.82843%2013.4987%203%2013.4987C2.17157%2013.4987%201.5%2014.1702%201.5%2014.9987C1.5%2015.8271%202.17157%2016.4987%203%2016.4987Z%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.5%203.49866H16.5%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.5%209.49866H16.5%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.5%2015.4987H16.5%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
